import { render } from "./cu-main.vue?vue&type=template&id=3400f6d9&scoped=true"
import script from "./cu-main.vue?vue&type=script&lang=js"
export * from "./cu-main.vue?vue&type=script&lang=js"

import "./cu-main.vue?vue&type=style&index=0&id=3400f6d9&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3400f6d9"]])

export default __exports__